///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { statusText } from "./types";

const getStatusColor = status => {
  if (status === statusText.pending) {
    return "#015C92";
  } else if (status === statusText.inProgress) {
    return "#53A6D8";
  } else if (status === statusText.submitted) {
    return "#534582";
  } else if (status === statusText.feedback) {
    return "#69C764";
  } else if (status === statusText.awarded) {
    return "#E0CD5C";
  } else if (status === statusText.lost) {
    return "#616161";
  } else if (status === statusText.archived || status === statusText.closed) {
    return "#343434";
  } else if (status === statusText.rejected) {
    return "#800000";
  }
};

export default getStatusColor;
